import React, { useState } from "react";
import VehicleLogsLive from "./VehicleLogsLive";
import VehicleLogsHistory from "./VehicleLogsHistory";
import VehicleLogsSearch from "./VehicleLogsSearch";

const VehicleLogs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"live" | "history" | "search">("search");

  return (
    <div>
      {/* Tab Navigation */}
      <div className="mb-6 flex gap-2 border-b border-gray-200 dark:border-gray-700">
        <button
          onClick={() => setActiveTab("search")}
          className={`px-6 py-3 font-semibold transition-colors border-b-2 ${
            activeTab === "search"
              ? "border-blue-600 text-blue-600 dark:text-blue-400"
              : "border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
          }`}
        >
          <i className="fa-solid fa-magnifying-glass mr-2"></i>
          Search
        </button>
        <button
          onClick={() => setActiveTab("live")}
          className={`px-6 py-3 font-semibold transition-colors border-b-2 ${
            activeTab === "live"
              ? "border-blue-600 text-blue-600 dark:text-blue-400"
              : "border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
          }`}
        >
          <i className="fa-solid fa-satellite-dish mr-2"></i>
          Live
        </button>
        <button
          onClick={() => setActiveTab("history")}
          className={`px-6 py-3 font-semibold transition-colors border-b-2 ${
            activeTab === "history"
              ? "border-blue-600 text-blue-600 dark:text-blue-400"
              : "border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
          }`}
        >
          <i className="fa-solid fa-clock-rotate-left mr-2"></i>
          History
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "search" && <VehicleLogsSearch />}
      {activeTab === "live" && <VehicleLogsLive />}
      {activeTab === "history" && <VehicleLogsHistory />}
    </div>
  );
};

export default VehicleLogs;
